"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withURLPrefix = exports.generateUUID = exports.getEditorInstance = exports.ScriptLoader = exports.isInDoc = exports.isBeforeInputEventAvailable = exports.mergePlugins = exports.isTextareaOrInput = exports.configHandlers = exports.configHandlers2 = exports.isFunction = void 0;

var globalEditor_1 = require("./globalEditor");

Object.defineProperty(exports, "getEditorInstance", {
  enumerable: true,
  get: function get() {
    return globalEditor_1.getEditorInstance;
  }
});

var scriptLoader_1 = require("./scriptLoader");

Object.defineProperty(exports, "ScriptLoader", {
  enumerable: true,
  get: function get() {
    return scriptLoader_1.ScriptLoader;
  }
});

var uuid_1 = require("./uuid");

Object.defineProperty(exports, "generateUUID", {
  enumerable: true,
  get: function get() {
    return uuid_1.generateUUID;
  }
});

var EditorPropTypes_1 = require("../types/EditorPropTypes");

var config_1 = require("../config");

var isFunction = function isFunction(x) {
  return typeof x === 'function';
};

exports.isFunction = isFunction;

var isEventProp = function isEventProp(name) {
  return name in EditorPropTypes_1.eventPropTypes;
};

var eventAttrToEventName = function eventAttrToEventName(attrName) {
  return attrName.substr(2);
};

var configHandlers2 = function configHandlers2(handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
  var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
  var currEventKeys = Object.keys(props).filter(isEventProp);
  var removedKeys = prevEventKeys.filter(function (key) {
    return props[key] === undefined;
  });
  var addedKeys = currEventKeys.filter(function (key) {
    return prevProps[key] === undefined;
  });
  removedKeys.forEach(function (key) {
    // remove event handler
    var eventName = eventAttrToEventName(key);
    var wrappedHandler = boundHandlers[eventName];
    off(eventName, wrappedHandler);
    delete boundHandlers[eventName];
  });
  addedKeys.forEach(function (key) {
    var wrappedHandler = adapter(handlerLookup, key);
    var eventName = eventAttrToEventName(key);
    boundHandlers[eventName] = wrappedHandler;
    on(eventName, wrappedHandler);
  });
};

exports.configHandlers2 = configHandlers2;

var configHandlers = function configHandlers(editor, prevProps, props, boundHandlers, lookup) {
  return (0, exports.configHandlers2)(lookup, editor.on.bind(editor), editor.off.bind(editor), function (handlerLookup, key) {
    return function (e) {
      var _a;

      return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor);
    };
  }, prevProps, props, boundHandlers);
};

exports.configHandlers = configHandlers;

var isTextareaOrInput = function isTextareaOrInput(element) {
  return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
};

exports.isTextareaOrInput = isTextareaOrInput;

var normalizePluginArray = function normalizePluginArray(plugins) {
  if (typeof plugins === 'undefined' || plugins === '') {
    return [];
  }

  return Array.isArray(plugins) ? plugins : plugins.split(' ');
}; // eslint-disable-next-line max-len


var mergePlugins = function mergePlugins(initPlugins, inputPlugins) {
  return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};

exports.mergePlugins = mergePlugins;

var isBeforeInputEventAvailable = function isBeforeInputEventAvailable() {
  return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function';
};

exports.isBeforeInputEventAvailable = isBeforeInputEventAvailable;

var isInDoc = function isInDoc(elem) {
  if (!('isConnected' in Node.prototype)) {
    // Fallback for IE and old Edge
    var current = elem;
    var parent_1 = elem.parentNode;

    while (parent_1 != null) {
      current = parent_1;
      parent_1 = current.parentNode;
    }

    return current === elem.ownerDocument;
  }

  return elem.isConnected;
};

exports.isInDoc = isInDoc;

var withURLPrefix = function withURLPrefix(env, urlPrefix, stem) {
  return urlPrefix ? "" + urlPrefix + stem : "" + config_1.config[env !== null && env !== void 0 ? env : 'staging'].defaultURLPrefix + stem;
};

exports.withURLPrefix = withURLPrefix;